<div class="flexie-auto-grid m-t-b-60">

    <div class="flex-self-vert-start">
      <div *ngIf="!savedAdd">
        <div class="zero-ui">
          <i nz-icon nzType="schedule" nzTheme="outline"></i>
          <h2>Add Occupation</h2>
          <p>You need to atleast one Occupation to continue</p>
        </div>
      </div>
      <div *ngIf="savedAdd">
        <h3> List of Occupations </h3>
        <nz-list [nzDataSource]="list" [nzItemLayout]="'horizontal'" [nzRenderItem]="item">
          <ng-template #item let-item>
            <nz-list-item [nzActions]="[editAction,moreAction]">
              <nz-skeleton [nzActive]="true" [nzLoading]="false">
                <ng-template #moreAction><a (click)="edit(item)">select as Preffered</a></ng-template>
                <ng-template #editAction><a (click)="edit(item)">edit</a></ng-template>
                <ng-template #moreAction><a (click)="view(item)">delete</a></ng-template>
                <nz-list-item-meta [nzTitle]="'Entrepreneur'" nzDescription="Yearly Income: Rp 10.008.989,835">
                </nz-list-item-meta>
              </nz-skeleton>
            </nz-list-item>
          </ng-template>
        </nz-list>
      </div>
    </div>
  
    <div>
      <div class="form-secondary">
  
        <h3 class="form-secondary-heading">+ Add Occupation</h3>
  
        <div class="form-secondary-fields p-l-r-20 p-t-b-10">
          
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Occupation</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="Eg: Entrepreneur" [(ngModel)]="Occupation" name="input-basic" />
            </nz-form-control>
          </nz-form-item>
  
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Yearly Income</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="Eg: Rp 10.008.989,835" [(ngModel)]="yearlyIncome" name="input-basic" />
            </nz-form-control>
          </nz-form-item>
        </div>
  
        <div class="footer-actions-bar">
          <div>
            <!-- Left -->
          </div>
          <div>
            <!-- Right -->
            <button nz-button class="b-0 m-r-10">Clear</button>
            <button nz-button [nzType]="'primary'" (click)="savedAdd=!savedAdd">Add</button>
          </div>
        </div>
      </div>
    </div>
  
  </div>
  